var map = {
	"./Livelihood-zoning.md": 639,
	"./Resume_Orfeas_Kypris_2021.pdf": 640,
	"./barchart.csv": 641,
	"./barkhausen.md": 642,
	"./firegaze.md": 643,
	"./minotaur.md": 644,
	"./navenio.md": 645,
	"./projects": 237,
	"./projects.json": 237,
	"./publications": 238,
	"./publications.bib": 646,
	"./publications.json": 238,
	"./roboweldar.md": 647,
	"./structalyse.md": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;